import React from 'react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry, className = '' }) => {
  return (
    <div className={`bg-neo-pink border-4 border-neo-black p-4 shadow-neo ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="text-neo-black font-bold text-lg mr-2">⚠️</div>
          <p className="text-neo-black font-medium">{message}</p>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="bg-neo-yellow border-3 border-neo-black px-4 py-2 font-bold text-neo-black hover:shadow-neo-sm transition-all duration-200 active:shadow-none active:translate-x-1 active:translate-y-1"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
